import { render, staticRenderFns } from "./CartSkeleton.vue?vue&type=template&id=8fd5f5bc"
import script from "./CartSkeleton.vue?vue&type=script&lang=js"
export * from "./CartSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports